import clsx from 'clsx';

import { Typography } from '../../typography';

import type { TypographyProps } from '../../typography';
import type { FieldVariant } from '../types';

import s from './Hint.module.css';

type FieldHintProps = Omit<TypographyProps<'span'>, 'color' | 'component' | 'variant'> & {
  disabled?: boolean;
  variant?: FieldVariant;
};

const getHintColor = (variant: FieldVariant, disabled: boolean = false): NonNullable<TypographyProps['color']> => {
  if (disabled) {
    return 'grey-light-opacity-40';
  }

  if (variant === 'danger') {
    return 'danger';
  }

  if (variant === 'accent') {
    return 'accent-alt';
  }

  if (variant === 'success') {
    return 'success';
  }

  return 'grey-light';
};

export const FieldHint = ({ children, className, disabled, id, variant = 'default', ...props }: FieldHintProps) => {
  const hintColor = getHintColor(variant, disabled);

  return (
    <Typography
      className={clsx(s.hint, className)}
      color={hintColor}
      component="span"
      id={id}
      variant="note"
      {...props}
    >
      {children}
    </Typography>
  );
};
